export const RESTRICTIONS = {
    'DE': ['DE', 'd'],
    'BIO': ['BIO', 'bio'], 
    'CH': ['CH', 'ch'],
    'PH': ['PH', 'ph'],
    'M': ['M', 'm'],

    'E': ['e'],

    'EK': ['EK', 'ge+ek/sk', 'ge/ek', 'sk/ek'],
    'GE': ['G', 'ge+ek/sk', 'ge/sk', 'ge/ek'],
    'SK': ['SK', 'ge+ek/sk', 'ge/sk', 'sk/ek'],
    'SP': ['SP', 'sp', 'ge/ek', 'sk/ek', 'ge/sk'], 
    
    'ge/sk': ['ge/sk', 'SK', 'GE', 'SP'], 
    'ge/ek': ['ge/ek', 'EK', 'GE', 'SP'],
    'sk/ek': ['sk', 'EK', 'SK', 'SP'],
    'ge+ek/sk': ['ge+ek/sk', 'GE', 'EK', 'SK', 'sp'], 

    'd': ['d', 'DE'],
    'e': ['e', 'E'],
    'f': ['f', 'E'],
    'bio': ['bio', 'BIO'],
    'ch': ['ch', 'CH'],
    'ph': ['ph', 'PH'],
    'm': ['m', 'M'],

    'sp': ['SP', 'ge+ek/sk']
};
